import { AxiosResponse } from 'axios'
import { ExchangeTokenRequest, ExchangeTokenResponse } from '@/types/auth'
import axios from '../auth-axios'
import useCreateDetail, {
  UseCreateDetailOptions,
} from '../core-hooks/useCreateDetail'
import { filtersToQueryString } from '../request-wrappers'

/**
 * MARK: Action Hook: Exchange Token
 * This hook provides a mutation to exchange an authentication token.
 */
export function useExchangeToken(
  options: UseCreateDetailOptions<
    ExchangeTokenRequest,
    ExchangeTokenResponse
  > = {},
) {
  const mutation = useCreateDetail<ExchangeTokenRequest, ExchangeTokenResponse>(
    {
      serviceFn: ({ item, filters, axiosOptions }) => {
        const searchParams = filtersToQueryString(filters)
        return axios.post<
          ExchangeTokenRequest,
          AxiosResponse<ExchangeTokenResponse>
        >(`/v2/auth/exchange_token?${searchParams}`, item, axiosOptions)
      },
      ...options,
    },
  )

  return {
    exchangeToken: mutation.mutate,
    exchangeTokenAsync: mutation.mutateAsync,
    ...mutation,
  }
}
